// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["autoFocus", "grouped", "name", "internalUsers", "clientUsers", "companies", "onChange", "onBlur", "placeholder", "styles", "ignoreCompanies", "ignoreFilterClientsByCompany", "limitSelectedOptions", "initialValue"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
import { useCallback, useMemo, useState } from 'react';
import Select from 'react-select';
import { ListItem } from "./ListItem";
import { Heading, Body } from "../Typography";
import { SelectedValueChip } from "./SelectedValueChip";
import { LimitedOptionsList } from "./LimitedOptionsList";
import { colors } from "../../theme/colors";

/**
 * Creates a grouped options for the combo select
 * @param companies - the companies to group
 * @param internalUsers - the internal users to group
 * @param clientUsers - the client users to group
 * @returns the grouped options
 */
var createGroupedOptions = function createGroupedOptions(companies, internalUsers, clientUsers) {
  var companyGroup = {
    label: 'Companies',
    options: companies
  };
  var internalUserGroup = {
    label: 'Internal Users',
    options: internalUsers
  };
  var clientUserGroup = {
    label: 'Client Users',
    options: clientUsers
  };
  return [internalUserGroup, clientUserGroup, companyGroup];
};
export var UserCompanySelector = function UserCompanySelector(_ref) {
  var _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$grouped = _ref.grouped,
    grouped = _ref$grouped === void 0 ? false : _ref$grouped,
    name = _ref.name,
    _ref$internalUsers = _ref.internalUsers,
    internalUsers = _ref$internalUsers === void 0 ? [] : _ref$internalUsers,
    clientUsers = _ref.clientUsers,
    companies = _ref.companies,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    placeholder = _ref.placeholder,
    styles = _ref.styles,
    ignoreCompanies = _ref.ignoreCompanies,
    _ref$ignoreFilterClie = _ref.ignoreFilterClientsByCompany,
    ignoreFilterClientsByCompany = _ref$ignoreFilterClie === void 0 ? false : _ref$ignoreFilterClie,
    _ref$limitSelectedOpt = _ref.limitSelectedOptions,
    limitSelectedOptionsUnvalidated = _ref$limitSelectedOpt === void 0 ? 1000 : _ref$limitSelectedOpt,
    initialValue = _ref.initialValue,
    others = _objectWithoutProperties(_ref, _excluded);
  var limitSelectedOptions = limitSelectedOptionsUnvalidated === 0 ? 1000 : Math.min(1000, limitSelectedOptionsUnvalidated);
  var companiesMap = useMemo(function () {
    return new Map(companies.map(function (company) {
      return [company.value, company];
    }));
  }, [companies]);
  var _useState = useState(initialValue !== null && initialValue !== void 0 ? initialValue : []),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOptions = _useState2[0],
    setSelectedOptions = _useState2[1];
  var options = useMemo(function () {
    var filteredClients = clientUsers;
    var filteredCompanies = companies;
    var filteredInternalUsers = internalUsers;
    var hasSelectedClients = selectedOptions.some(function (option) {
      return option.type === 'client';
    });
    var hasSelectedCompanies = selectedOptions.some(function (option) {
      return option.type === 'company';
    });
    var hasReachedLimit = selectedOptions.length >= limitSelectedOptions;
    if (hasSelectedCompanies && limitSelectedOptions > 1 || hasReachedLimit) {
      filteredClients = [];
      filteredCompanies = [];
      filteredInternalUsers = [];
    }
    if (hasSelectedClients && limitSelectedOptions > 1) {
      // if the input has selected clients, we need to filter the clients to only show other
      // clients within the same company.
      filteredClients = ignoreFilterClientsByCompany ? clientUsers : clientUsers.filter(function (client) {
        return hasSelectedClients && selectedOptions.map(function (option) {
          return option.companyId;
        }).includes(client.companyId);
      });
      filteredCompanies = [];
      filteredInternalUsers = [];
    }

    // when grouped is true then we need to show the options list in a group manner.
    var opts = grouped ? createGroupedOptions(filteredCompanies, filteredInternalUsers, filteredClients) : [].concat(_toConsumableArray(filteredInternalUsers), _toConsumableArray(filteredClients), _toConsumableArray(filteredCompanies));
    return opts;
  }, [internalUsers, clientUsers, companies, grouped, selectedOptions, ignoreFilterClientsByCompany, limitSelectedOptions]);

  /**
   * Handles the change of the selected options
   * @param value - the selected options
   */
  var handleChange = function handleChange(value) {
    var selectedOptionsValue = [];
    if (value.length > limitSelectedOptions) {
      if (value.length === 2 && limitSelectedOptions === 1) {
        var newSelectedOption = value[1];
        if (newSelectedOption) {
          var _newSelectedOption$co;
          setSelectedOptions([newSelectedOption]);
          selectedOptionsValue = [{
            id: newSelectedOption.value,
            companyId: (_newSelectedOption$co = newSelectedOption.companyId) !== null && _newSelectedOption$co !== void 0 ? _newSelectedOption$co : '',
            object: newSelectedOption.type
          }];
        }
      } else {
        selectedOptionsValue = value.slice(0, -1).map(function (_ref2) {
          var id = _ref2.value,
            object = _ref2.type,
            companyId = _ref2.companyId;
          return {
            id: id,
            companyId: companyId !== null && companyId !== void 0 ? companyId : '',
            object: object
          };
        });
      }
    } else {
      setSelectedOptions(value);
      selectedOptionsValue = value.map(function (_ref3) {
        var id = _ref3.value,
          object = _ref3.type,
          companyId = _ref3.companyId;
        return {
          id: id,
          companyId: companyId !== null && companyId !== void 0 ? companyId : '',
          object: object
        };
      });
    }
    onChange(selectedOptionsValue);
  };

  /**
   * This function pupulates the company name and avatar for the client options
   * @param option - the option to get the company data for
   * @returns the option with the company data
   */
  var getCompanyData = useCallback(function (option) {
    var _option$companyId;
    var company = companiesMap.get((_option$companyId = option.companyId) !== null && _option$companyId !== void 0 ? _option$companyId : '');
    return _objectSpread(_objectSpread({}, option), {}, {
      companyName: company === null || company === void 0 ? void 0 : company.label,
      companyAvatarSrc: company === null || company === void 0 ? void 0 : company.avatarSrc,
      companyAvatarFallbackColor: company === null || company === void 0 ? void 0 : company.avatarFallbackColor
    });
  }, [companiesMap]);
  var handleFilterOption = useCallback(function (option, inputValue) {
    var lowerCaseInputValue = inputValue.toLowerCase();
    if (ignoreCompanies && option.data.type === 'company') {
      return false;
    }
    var optionLabel = option.data.label.toLowerCase();
    // for clients option, we should filter by company name too
    // e.g. if a client company is ACME and the input is ACME, the result should
    // show the client with the company ACME and the client with the company name
    // ACME
    if (option.data.type === 'client') {
      var _option$data$companyI, _clientCompany$label;
      var clientCompany = companiesMap.get((_option$data$companyI = option.data.companyId) !== null && _option$data$companyI !== void 0 ? _option$data$companyI : '');
      var companyName = clientCompany === null || clientCompany === void 0 || (_clientCompany$label = clientCompany.label) === null || _clientCompany$label === void 0 ? void 0 : _clientCompany$label.toLowerCase();
      if (companyName !== null && companyName !== void 0 && companyName.includes(lowerCaseInputValue)) {
        return true;
      }
    }
    return optionLabel.includes(lowerCaseInputValue);
  }, [ignoreCompanies, companiesMap]);

  /**
   * This is a memoized object that defines the custom components for the combo select
   */
  var memoizedComponents = useMemo(function () {
    return {
      NoOptionsMessage: function NoOptionsMessage() {
        return /*#__PURE__*/React.createElement("div", {
          className: "cop-flex cop-h-8 cop-items-center cop-gap-2 cop-px-3"
        }, /*#__PURE__*/React.createElement(Body, {
          className: "cop-text-[12px] cop-text-primary"
        }, "No results found"));
      },
      GroupHeading: function GroupHeading(props) {
        return /*#__PURE__*/React.createElement("div", {
          className: "cop-flex cop-h-8 cop-items-center cop-gap-2 cop-px-3"
        }, /*#__PURE__*/React.createElement(Heading, {
          className: "cop-text-secondary",
          size: "xs"
        }, props.data.label));
      },
      Option: function Option(props) {
        return /*#__PURE__*/React.createElement(ListItem, _extends({}, props, {
          data: getCompanyData(props.data)
        }));
      },
      DropdownIndicator: function DropdownIndicator() {
        return null;
      },
      MultiValue: function MultiValue(props) {
        return /*#__PURE__*/React.createElement(SelectedValueChip, _extends({}, props, {
          data: getCompanyData(props.data)
        }));
      },
      MenuList: function MenuList(props) {
        return /*#__PURE__*/React.createElement(LimitedOptionsList, _extends({}, props, {
          isGroup: false
        }));
      },
      Group: function Group(props) {
        return /*#__PURE__*/React.createElement(LimitedOptionsList, _extends({}, props, {
          isGroup: true
        }));
      }
    };
  }, [getCompanyData]);
  return /*#__PURE__*/React.createElement(Select, _extends({
    autoFocus: autoFocus,
    isMulti: true,
    name: name,
    options: options,
    filterOption: handleFilterOption,
    onChange: handleChange,
    onBlur: onBlur,
    placeholder: placeholder,
    unstyled: true,
    styles: _objectSpread({
      clearIndicator: function clearIndicator() {
        return {
          display: 'none' // hide the clear button. Unfortunatelly, the class specificity is not enough to override the default styles.
        };
      },
      placeholder: function placeholder(base) {
        return _objectSpread(_objectSpread({}, base), {}, {
          color: colors.gray[500]
        });
      }
    }, styles),
    classNames: {
      valueContainer: function valueContainer() {
        return 'cop-flex cop-gap-2';
      },
      input: function input() {
        return 'cop-text-primary hover:cop-cursor-text';
      },
      menuList: function menuList() {
        return 'cop-relative cop-bg-white cop-shadow-popover-50 cop-rounded cop-border cop-border-solid cop-border-secondary cop-mt-1';
      },
      control: function control() {
        return 'cop-border-solid cop-border-[1px] cop-border-secondary focus-within:cop-border-primary cop-px-3 cop-py-[9px] cop-rounded';
      }
    },
    components: memoizedComponents,
    value: selectedOptions
  }, others));
};
